




























import Vue from "vue";
export default Vue.extend({
  inheritAttrs: false,
  data() {
    return {
      isFocused: false,
      val: null,
      isActive: false
    };
  },
  props: {
    value: {
      type: [String],
      default: ""
    },
    autofocus: {
      type: Boolean
    },
    edit: {
      type: Function
    },
    height: {
      type: Number
    },
    white: {
      type: Boolean
    }
  },
  methods: {
    save() {
      this.$emit("save", this.val);
      this.isActive = false;
      (this.$refs.textarea as HTMLTextAreaElement).blur();
    },
    onInput(e) {
      this.val = (e.target as HTMLTextAreaElement).value;
      this.isActive = true;
    },
    clickOutside(e: any) {
      if (!this.isActive) return;
      if (!(this.$refs.container as HTMLDivElement).contains(e.target)) {
        this.save();
      }
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.val = this.value;
    }
  },
  mounted() {
    this.val = this.value;
  },
  created() {
    window.addEventListener("click", this.clickOutside);
  },
  destroyed() {
    window.removeEventListener("click", this.clickOutside);
  }
});
